import { api } from "../base";

export interface QuotingAccountRouting {
  executable_streaming_prices?: string;
  request_for_quote?: string;
  request_for_stream?: string;
  order_entry?: string;
}

const quotingEndpoints = api.injectEndpoints({
  endpoints: (build) => ({
    getQuotingAccountRouting: build.query<QuotingAccountRouting, void>({
      query: () => ({
        url: "/api/trade/v1/quoting-account-routing",
      }),
    }),
  }),
});

export const {
  useGetQuotingAccountRoutingQuery,
  endpoints: quotingApiEndpoints,
} = quotingEndpoints;
